import * as Common from '@/tenant/common';


export class Picking extends Common.StateObject2{
  constructor(){
    super('Picking')
    this.binders.segment = new Common.ModelBinder(Common.Segment);
    this.binders.warehouse = new Common.ModelBinder(Common.Counterpart);
  }
    public pickingNo:string;
    public segment:Common.Segment;
    public warehouse:Common.Counterpart;
    public deliveryDate:Date;
    public pic:string;
    public description:string;
}


export class PickingItem extends Common.ObjectBase{
  constructor(){
    super('PickingItem')
    this.binders.commodity = new Common.ModelBinder(Common.Commodity);
    this.binders.sku = new Common.ModelBinder(Common.SKU);
    this.binders.uom = new Common.ModelBinder(Common.Conversion);
  }
    public pickingNo:string;       
    public seqNo:number;
    public pickingItemNo:string;
    public commodity:Common.Commodity; 
    public sku:Common.SKU;
    public uom:Common.Conversion;      
    public package:string;
    public quantity:number;
    public scannedQuantity:number;
    public isScanCompleted:boolean;
}

export enum PickingStatus
{
    WaitPicking = 1, //ピッキング待ち
    UnderPicking = 2, //ピッキング中
    WaitShipping = 4, //出荷完了待ち
    Completed = 8,　//出荷完了
    NotCompleted = WaitPicking | UnderPicking | WaitShipping //出荷完了以外
}

export class PickingQuery extends Common.LoadQuery {
  constructor(){
    super('PickingQuery',Picking);
    this.sort = 'pickingNo';
  }
  public segment: Common.Segment = null;
  public warehouse: Common.Counterpart = null;
  public pic: string = "";
  public pickingNo: string = "";
  public deliveryDateFrom: Date = null;
  public deliveryDateTo: Date = null;
  public initialSavedOnFrom: Date = null;
  public initialSavedOnTo: Date = null;
  public lastUpdatedOnFrom: Date = null;
  public lastUpdatedOnTo: Date = null;
  public state: Common.PickingStatus = Common.PickingStatus.NotCompleted;
}

export class CreatePickingQuery extends Common.Query {
  constructor(items: Common.Delivery[], deliveryDate: Date, description:string, pic:string){
    super('CreatePickingQuery',new Common.ModelBinder(Common.SalesDelivery,true));
    this.items = items;
    this.deliveryDate = deliveryDate;
    this.description = description;
    this.pic = pic;
  }  
  public items: Common.Delivery[];
  public deliveryDate: Date;
  public description: string;
  public pic:string;
}

export class PickingItemQuery extends Common.LoadQuery {
  constructor(){
    super('PickingItemQuery',PickingItemQuery);
    this.sort = 'pickingItemNo';
  }
  public pickingNo: string = "";
}